var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_4128_48386)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4128_48386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9601 24.9102C7.97412 24.0297 5.50225 21.957 4.09131 19.25H7.95771C8.69053 21.6289 9.84443 23.5102 10.9601 24.9102ZM12.7757 22.9688C12.0319 21.9844 11.2827 20.7484 10.7249 19.2445H17.6374C17.0796 20.743 16.3358 21.9789 15.5866 22.9688C15.0999 23.6141 14.6132 24.15 14.1812 24.5766C13.7491 24.15 13.2624 23.6141 12.7757 22.9688ZM9.80615 14C9.80615 13.0648 9.88272 12.1953 10.0249 11.375H18.3374C18.4741 12.1953 18.5562 13.0648 18.5562 14C18.5562 14.9352 18.4796 15.8047 18.3374 16.625H10.0249C9.88818 15.8047 9.80615 14.9352 9.80615 14ZM7.36709 11.375C7.24678 12.2008 7.18115 13.0758 7.18115 14C7.18115 14.9242 7.24678 15.7992 7.36709 16.625H3.1124C2.91553 15.7828 2.80615 14.9023 2.80615 14C2.80615 13.0977 2.91006 12.2172 3.1124 11.375H7.36709ZM10.7249 8.75C11.2827 7.25156 12.0265 6.01562 12.7757 5.02578C13.2624 4.38047 13.7491 3.84453 14.1812 3.41797C14.6132 3.84453 15.0999 4.38047 15.5866 5.02578C16.3304 6.01016 17.0796 7.24609 17.6374 8.75H10.7249ZM20.9952 11.375H25.2499C25.4468 12.2172 25.5562 13.0977 25.5562 14C25.5562 14.9023 25.4522 15.7828 25.2499 16.625H20.9952C21.1155 15.7992 21.1812 14.9242 21.1812 14C21.1812 13.0758 21.1155 12.2008 20.9952 11.375ZM24.2765 8.75H20.4046C19.6718 6.37109 18.5179 4.48984 17.4022 3.08984C20.3882 3.97031 22.8601 6.04297 24.271 8.75H24.2765ZM7.95771 8.75H4.08584C5.49678 6.0375 7.97412 3.97031 10.9546 3.08984C9.83896 4.48984 8.68506 6.37109 7.95225 8.75H7.95771ZM17.4022 24.9102C18.5179 23.5102 19.6718 21.6289 20.4046 19.25H24.271C22.8601 21.9625 20.3827 24.0297 17.4022 24.9102ZM14.1812 28C17.8942 28 21.4551 26.525 24.0806 23.8995C26.7062 21.274 28.1812 17.713 28.1812 14C28.1812 10.287 26.7062 6.72601 24.0806 4.10051C21.4551 1.475 17.8942 0 14.1812 0C10.4681 0 6.90717 1.475 4.28166 4.10051C1.65615 6.72601 0.181152 10.287 0.181152 14C0.181152 17.713 1.65615 21.274 4.28166 23.8995C6.90717 26.525 10.4681 28 14.1812 28Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4128_48386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.181152)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4128_48386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.181152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.cc17c4de1179c0347b851d606ec1ff6d.svg";
export { ForwardRef as ReactComponent };